import { render, staticRenderFns } from "./ResultsReadyPage.vue?vue&type=template&id=54c2d3bc&scoped=true"
import script from "./ResultsReadyPage.vue?vue&type=script&lang=ts"
export * from "./ResultsReadyPage.vue?vue&type=script&lang=ts"
import style0 from "./ResultsReadyPage.vue?vue&type=style&index=0&id=54c2d3bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2d3bc",
  null
  
)

export default component.exports